import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5mejd59pc: FaireProductEntity = {
  token: "p_q5mejd59pc",
  type: "product",
  name: "Pressed Highlighter – Natural Shimmer | Clean Makeup",
  brandToken: "b_aswupcvq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1fc5d5dda8205e004757de5cb7a3b3529e6b6ddcff0596f733e921ab8c91e517.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f264ccf9db509321d61b4f22e3e9bbdc796876ba89bece9a37fea63d7f058e7b.jpeg",
  ],
  priceDollars: 31.5,
  description:
    "This sheer, buildable highlighter enhances your natural radiance with a healthy, light-reflecting glow—without adding unwanted texture or shimmer fallout. Our finely milled pressed powder applies smoothly and melts into the skin for a luminous finish that looks lit-from-within, not glittery or cakey.\n\nFormulated with jojoba oil, Vitamin E, and lavender, this highlighter helps soften and nourish the skin while you wear it. Perfect for highlighting cheekbones, brow bones, and the bridge of the nose—where the light naturally hits.\n\nRetailers love it for its natural finish, clean ingredient list, and shelf-ready packaging that appeals to minimalists and glow-getters alike.\n\nKey Features:\n- Infused with jojoba, Vitamin E, and lavender\n- Skin-softening, and breathable\n- Free from parabens, talc, phthalates, and synthetic fragrance\n- Vegan & cruelty-free\n- mineral-based pigments\n\nPerfect For:\nClean beauty retailers, wellness boutiques",
  tags: [],
  msrpDollars: 63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:18.243Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
